import Vue from 'vue'
import Vuetify from 'vuetify'
import colors from 'vuetify/lib/util/colors'
import 'vuetify/dist/vuetify.min.css'
import '@fortawesome/fontawesome-free/css/all.css'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'fa', // default - only for display purposes
  },
  theme: {
    options: {
      customProperties: true,
    },
    primary: process.env.VUE_APP_ENV_NAME !== 'prod' ? colors.teal : colors.indigo,
    secondary: colors.deepPurple,
    'secondary-lighten-2': colors.deepPurple.lighten2,
    'secondary-darken-2': colors.deepPurple.darken2,
    accent: colors.cyan,
    error: colors.red,
    warning: colors.orange,
    info: colors.blue,
    success: colors.green,
    themes: {
      light: {
        primary: process.env.VUE_APP_ENV_NAME !== 'prod' ? colors.teal : colors.indigo,
        secondary: colors.orange,
        'secondary-lighten-2': colors.orange.lighten2,
        'secondary-darken-2': colors.orange.darken2,
        accent: colors.cyan,
        error: colors.red,
        warning: colors.orange,
        info: colors.blue,
        success: colors.green,
      },
    },
  },
})
